import React, { useState } from 'react';

export default ({ label, handleChange, value, type = 'text', setEye = false, name, placeholder, required = false, id, dark = false, error = false }) => {

    const [inputType, setInputType] = useState(type);

    const changeInputType = () => {
        setInputType(inputType === 'password' ? 'text' : 'password');
    };
    return <div className="mb-3">
        {
            dark
                ? <label className="form-label text-white fw-bold" style={{ textShadow: '1px 1px 0px black' }} htmlFor={id}>{label}</label>
                : label ? <label className="form-label text-primary fw-bold" htmlFor={id}>{label}</label> : null
        }

        {
            type === "password"
                ? <div className="">
                    <div className={`input-group input-group-merge ${error ? 'border border-danger' : ''}`}>
                        <input
                            type={inputType}
                            className={`form-control form-control-lg`}
                            name={name}
                            id={id}
                            value={value}
                            required={required}
                            onChange={handleChange}
                            placeholder={placeholder}
                        />
                        <span onClick={changeInputType} className="js-toggle-password-target-1 input-group-append input-group-text"
                            style={{ cursor: "pointer" }}>
                            <i className="js-toggle-passowrd-show-icon-1 bi-eye-slash"></i>
                        </span>
                    </div>
                    {error && <div style={{ display: 'block' }} className="invalid-feedback">{error}</div>}
                </div>
                : <input
                    type={type}
                    className="form-control form-control-lg"
                    name={name}
                    id={id}
                    value={value}
                    required={required}
                    onChange={handleChange}
                    placeholder={placeholder}
                />
        }


    </div>
};
